import { BookmarkPlus, Headphones, NotebookPen, Pause } from "lucide-react";

// Make the timestamp-to-memory loop tangible before asking for a click.
export function MemoryPreview() {
  return (
    <div className="hero-preview relative mx-auto w-full max-w-xl px-1 py-6 sm:px-8 sm:py-10">
      <div className="preview-player relative z-10 overflow-hidden rounded-2xl border border-white/15 text-white shadow-2xl">
        <div className="preview-audio relative aspect-[16/8.7] p-5 sm:p-7">
          <div className="flex items-center justify-between">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-black/20 px-2.5 py-1 font-mono text-[9px] tracking-[0.1em] uppercase backdrop-blur">
              <Headphones className="size-3" /> RSS audio
            </span>
            <span className="font-mono text-[9px] tracking-[0.12em] uppercase opacity-60">
              The Long Signal · 48
            </span>
          </div>
          <p className="absolute right-6 bottom-6 left-6 max-w-md font-serif text-2xl leading-tight font-semibold sm:text-3xl">
            Attention Is a Place We Choose to Live
          </p>
          <span className="absolute -top-12 -right-10 size-48 rounded-full border border-white/15" />
          <span className="absolute -top-3 right-4 size-48 rounded-full border border-white/10" />
        </div>
        <div className="bg-ink px-4 py-4 sm:px-5">
          <div className="flex items-center gap-3">
            <span
              aria-hidden="true"
              className="grid size-8 place-items-center rounded-full bg-white text-black"
            >
              <Pause className="size-3.5" />
            </span>
            <span className="font-mono text-[10px] font-semibold">42:18</span>
            <div className="h-1 flex-1 overflow-hidden rounded-full bg-white/20">
              <div className="bg-paper h-full w-[58%]" />
            </div>
            <span className="font-mono text-[10px] opacity-55">1:13:04</span>
          </div>
        </div>
      </div>

      <div className="paper-card preview-note relative z-20 -mt-3 ml-auto w-[92%] rotate-[1.2deg] rounded-2xl p-5 shadow-2xl sm:w-[82%] sm:p-6">
        <div className="flex items-center justify-between">
          <span className="text-primary inline-flex items-center gap-2 font-mono text-xs font-semibold">
            <BookmarkPlus className="size-3.5" /> 42:18
          </span>
          <span className="text-muted-foreground font-mono text-[9px] tracking-[0.12em] uppercase">
            Paused here
          </span>
        </div>
        <p className="mt-4 font-serif text-lg leading-7 font-semibold sm:text-xl">
          Attention is a place we choose to live
        </p>
        <div className="text-muted-foreground mt-4 flex items-start gap-2 border-t pt-4 text-sm">
          <NotebookPen className="text-primary/55 mt-0.5 size-3.5 shrink-0" />
          <p>
            Where do I keep choosing to live? A humane environment makes the
            good choice feel nearby.
          </p>
        </div>
      </div>

      <span className="bg-primary absolute top-1/2 -left-2 size-3 rounded-full sm:left-3" />
      <span className="border-primary absolute top-9 right-0 size-8 rounded-full border sm:right-4" />
    </div>
  );
}
